<template>
    <div>
        <v-container fluid pt-0 grid-list-xl>
            <section-tooltip :title="viewType === 'picture' ? $t('paddockPicturePass') : $t('paddockTransferable')"></section-tooltip>
            <app-card customClasses="mb-30 inherit-overflow">
                <div>
                    <h3>Contact Formula 1</h3>
                </div>
                <div class="partner-contact-container">
                    <v-form v-model="valid">
                        <v-layout row wrap>
                            <v-flex md2>
                                <v-text-field v-model="user.partnerDetailsContact.name" :rules="nameRules" label="Name"
                                    required>
                                </v-text-field>
                            </v-flex>
                            <v-flex md2>
                                <v-text-field v-model="user.partnerDetailsContact.mobile"
                                    label="Mobile" required>
                                </v-text-field>
                            </v-flex>
                            <v-flex md4>
                                <v-text-field v-model="user.partnerDetailsContact.email" :rules="emailRules"
                                    label="E-mail" required>
                                </v-text-field>

                            </v-flex>
                            <v-flex md1>
                                <v-btn color="primary" @click="saveContact()">
                                    <v-icon style="margin-right:10px">
                                        save
                                    </v-icon>
                                    Save
                                </v-btn>
                            </v-flex>
                        </v-layout>

                    </v-form>
                </div>
                <v-data-table 
                    v-bind:headers="headers" 
                    :items="guestDetailEvents" 
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="pagination"
                    >
                        <template 
                            slot="items" 
                            slot-scope="props"
                        >
                            <td @click="showEvent(props.item._id)">{{ props.item.dateFrom }}</td>
                            <td @click="showEvent(props.item._id)">{{ props.item.dateTo }}</td>
                            <td @click="showEvent(props.item._id)">{{ props.item.eventName }}</td>
                        </template>
                </v-data-table>
            </app-card>
        </v-container>
    </div>

</template>
<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters([
            'guestDetailEvents',
            'user',
            'season'
        ]),
    },
    watch: {
        $route(to, from) {
            this.viewType = to.query.type;
        }
    } ,
    data() {
        return {
            headers: [
                {
                    text: 'Date From',
                    value: "dateFrom",
                    align: 'left',
                },
                {
                    text: 'Date To',
                    value: "dateTo",
                    align: 'left',
                },
                {
                    text: 'Event',
                    value: "eventName",
                    align: 'left',
                }
            ],
            viewType: "",
            valid: false,
            nameRules: [
                v => !!v || 'Name is required'
            ],
            mobileRules: [
                v => !!v || 'Field is required',
                v => /^(\+\d{1,3}[- ]?)?\d{10}$/.test(v) || 'Mobile must be valid'
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid',
            ],
            rowsPerPageItems: [10, 20, 30, 40],
            pagination: {
                rowsPerPage: 40
            },
        }
    },
    methods: {
        saveContact() {
            this.$store.dispatch('updateUserDetailsContact', this.user.partnerDetailsContact);
        },
        showEvent(id) {
            this.$router.push({
                name: 'guest-details.event-partner',
                params: {
                    eventId: id,
                }
            });
        }
    },
    created() {
        if (!this.user.partnerDetailsContact) {
            this.user.partnerDetailsContact = {
                name: '',
                mobile: '',
                email: ''
            }
        }
        this.$store.dispatch('getGuestDetailsEvents', { companyId: this.user.company.id, seasonId: this.season });

    }
}
</script>